let api_token;

switch (window.Shopify.shop) {
  case "fostr-underscore.myshopify.com":
    api_token = "206fa93198662aeb44f1a671aa9f45f4"; // Dev Store
    break;
}

window.API_VERSION = "2023-10";
if (api_token) window.API_ACCESS = api_token;

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}
class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle("disabled", value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class VariantSelects extends HTMLElement {
  constructor() {
    super();

    document
      .querySelectorAll(
        '.product-form__input input[type="radio"], .product-form__input select'
      )
      .forEach((option) =>
        option.addEventListener("change", this.whichInputUpdated.bind(option))
      );

    this.addEventListener("change", this.onVariantChange);
  }

  whichInputUpdated(element) {
    var optionname = element.target
      .closest(".product-form__input")
      .querySelector(".form__label").dataset.optionname;

    document
      .querySelectorAll(`.product-form__input`)
      .forEach((option) => option.classList.remove("activeset"));

    document
      .querySelectorAll(`.form__label[data-optionname="${optionname}"]`)
      .forEach((option) =>
        option.closest(".product-form__input").classList.add("activeset")
      );
  }

  onVariantChange() {
    this.removeErrorMessage();
    this.updateOptions();
    this.updateMasterId();
    this.updateVariantInput();
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`
    );
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true
      )
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );

    const inputWrappers = [...this.querySelectorAll(".product-form__input")];

    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.innerText = input.getAttribute("value");
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace(
          "[value]",
          input.getAttribute("value")
        );
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const destinationSticky = document.getElementById(
          `price-${this.dataset.section}-support`
        );

        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`
        );
        const inventorySource = html.getElementById(
          `Inventory-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`
        );

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (source && destinationSticky)
          destinationSticky.innerHTML = source.innerHTML;

        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            "visibility-hidden",
            skuSource.classList.contains("visibility-hidden")
          );
        }

        const price = document.getElementById(`price-${this.dataset.section}`);
        const priceSticky = document.getElementById(
          `price-${this.dataset.section}-support`
        );

        if (price) price.classList.remove("visibility-hidden");
        if (priceSticky) priceSticky.classList.remove("visibility-hidden");

        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            "visibility-hidden",
            inventorySource.innerText === ""
          );

        const addButtonUpdated = html.getElementById(
          `ProductSubmitButton-${sectionId}`
        );

        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );

    if (!productForm) return;

    const stickyAtcButton = document.getElementById(
      `sticky-${this.dataset.section}`
    );

    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    const addButtonSticky = stickyAtcButton?.querySelector('[name="add"]');
    const addButtonTextSticky = stickyAtcButton?.querySelector(
      '[name="add"] > span'
    );

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (addButtonSticky) addButtonSticky.setAttribute("disabled", "disabled");
      if (text) {
        addButtonText.textContent = text;
        if (addButtonSticky) addButtonTextSticky.textContent = text;
      }
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;

      if (addButtonSticky) {
        addButtonSticky.removeAttribute("disabled");
        addButtonTextSticky.textContent = window.variantStrings.addToCart;
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const stickyAtcButton = document.getElementById(
      `sticky-${this.dataset.section}`
    );

    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');

    const addButtonSticky = stickyAtcButton?.querySelector('[name="add"]');
    const addButtonTextSticky = stickyAtcButton?.querySelector(
      '[name="add"] > span'
    );

    const price = document.getElementById(`price-${this.dataset.section}`);
    const priceSticky = document.getElementById(
      `price-${this.dataset.section}-support`
    );

    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;

    if (addButtonSticky)
      addButtonTextSticky.textContent = window.variantStrings.unavailable;

    if (price) price.classList.add("visibility-hidden");
    if (priceSticky) priceSticky.classList.add("visibility-hidden");

    if (inventory) inventory.classList.add("visibility-hidden");
    if (sku) sku.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  updatePairUI(paired, original) {
    var originalTagName = original.tagName.toLowerCase();
    var pairedTagName = paired.tagName.toLowerCase();
    var originalSelectedItem = "";
    var originalSelectedItemValue = "";

    if (originalTagName.includes("selects")) {
      var itemSelect = original.querySelector(".activeset select");
      originalSelectedItem = itemSelect.options[itemSelect.selectedIndex];
      originalSelectedItemValue = originalSelectedItem.value;
    } else {
      originalSelectedItem = original.querySelector(
        '.activeset input[type="radio"]:checked'
      );
      originalSelectedItemValue = originalSelectedItem.value;
    }

    if (pairedTagName.includes("selects")) {
      var event = new Event("change");
      paired.querySelector(".activeset select").value =
        originalSelectedItemValue;
      paired
        .querySelector(
          `.activeset option[data-value="${originalSelectedItemValue}"`
        )
        .click();
      paired.dispatchEvent(event);
    } else {
      paired.querySelector(
        `.activeset input[type="radio"]:checked`
      ).checked = false;
      var newTarget = paired
        .querySelector(
          `.activeset label[data-value="${originalSelectedItemValue}"`
        )
        .getAttribute("for");
      paired.querySelector(
        `.activeset input[type="radio"]#${newTarget}`
      ).checked = true;
    }
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll(".js-variant-radio-options"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

class ReadMore extends HTMLElement {
  constructor() {
    super();

    this.init();
  }

  init() {
    const toggle = this.querySelector(".js-read-more-toggle");
    toggle.addEventListener("click", () => {
      this.classList.toggle("read-more--clipped");
    });
  }
}

customElements.define("read-more", ReadMore);

//Add to bag functionality
class AddProduct extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", () => {
      this.addProduct();
    });
  }

  closeDrawer() {
    if (this.closest("side-drawer")) {
      this.closest("side-drawer").close();
    }
  }

  async addProduct() {
    this.classList.add("loading");
    this.setAttribute("disabled", true);
    const variantId = this.getAttribute("data-id");
    const template = this.getAttribute("data-template");

    let quantity = 1;

    if (this.getAttribute("data-quantity")) {
      const quantityInput = document.getElementById(
        this.getAttribute("data-quantity")
      );

      if (quantityInput) {
        quantity = parseInt(quantityInput.value);
      }
    }

    let properties = {};

    if (this.querySelectorAll(".js-property").length > 0) {
      this.querySelectorAll(".js-property").forEach((property) => {
        const key = property.getAttribute("data-key");
        const value = property.getAttribute("data-value");
        properties[key] = value;
      });
    }

    let productObj = {
      id: variantId,
      quantity: quantity,
      properties: properties,
    };

    let data = JSON.stringify(productObj);
    fetch('/cart/add.js', {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: data,
    }).then(() => {
      this.closeDrawer();
      this.classList.remove("loading");
      this.removeAttribute("disabled");
      publish(PUB_SUB_EVENTS.cartAdd, {
        source: "product-card",
        template: template,
        productVariantId: variantId,
      });
    });
  }
}

customElements.define("add-product", AddProduct);

class CustomSelect extends HTMLElement {
  constructor() {
    super();

    this.mainSelect = this.querySelector("select");
    this.mainLabel = this.querySelector("label");
    this.mainIcon = this.querySelector("svg");
    this.iconPlacement = this.dataset.iconPlacement || "before";
    this.selectStyle = this.dataset.style || "default";
    this.selectType = this.dataset.type || "default";
    this.randomId = Math.random().toString(36).substring(7);

    this.selectTemplate = document.createElement("template");

    if (this.mainIcon) {
      this.mainIcon.remove();
      this.iconHTML = this.mainIcon.outerHTML;
    } else {
      this.iconHTML = "";
    }

    if (this.selectType === "default") {
      this.selectTemplate.innerHTML = `
      <div id="select-${this.randomId}" class="custom-select style-${
        this.selectStyle
      }" tabindex="0" >
        ${this.iconPlacement == "before" ? this.mainIcon.outerHTML : ""}
        <div class="select-selected" role="button" aria-controls="select-${
          this.randomId
        }" aria-expanded="false"  aria-controls="select-options-${
        this.randomId
      }" >
          <div class="select-label"></div>
          <div class="selected-item"></div>
          <div class="select-arrow">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" aria-hidden="true" focusable="false" class="icon icon-caret icon-custom-select-arrow" fill="none">
              <path d="M8.23572 8.59987L11.3024 5.5332L12.0049 6.2357L8.23572 10.0049L4.46655 6.2357L5.16905 5.5332L8.23572 8.59987Z" fill="currentColor"/>
            </svg>
          </div>
        </div>
        ${this.iconPlacement == "after" ? this.mainIcon.outerHTML : ""}
        <div id="select-options-${
          this.randomId
        }" class="select-items select-hide" role="listbox"></div>
      </div>
    `;
    } else if (this.selectType === "collection-sort") {
      this.selectTemplate.innerHTML = `
      <div id="select-${this.randomId}" class="custom-select style-${
        this.selectStyle
      }" tabindex="0" >
        ${this.iconPlacement == "before" ? this.mainIcon.outerHTML : ""}
        <div class="select-selected" role="button" aria-controls="select-${
          this.randomId
        }" aria-expanded="false"  aria-controls="select-options-${
        this.randomId
      }" >
          <div class="select-label"></div>
        </div>
        ${this.iconPlacement == "after" ? this.mainIcon.outerHTML : ""}
        <div id="select-options-${
          this.randomId
        }" class="select-items select-hide" role="listbox"></div>
      </div>
    `;
    } else if (this.selectType === "links") {
      this.selectTemplate.innerHTML = `
      <div id="select-${this.randomId}" class="custom-select style-${
        this.selectStyle
      }" tabindex="0" >
        ${this.iconPlacement == "before" ? this.iconHTML : ""}
        <div class="select-selected" role="button" aria-controls="select-${
          this.randomId
        }" aria-expanded="false"  aria-controls="select-options-${
        this.randomId
      }" >
          <div class="select-label"></div>
          <div class="select-arrow">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" aria-hidden="true" focusable="false" class="icon icon-caret icon-custom-select-arrow" fill="none">
              <path d="M8.23572 8.59987L11.3024 5.5332L12.0049 6.2357L8.23572 10.0049L4.46655 6.2357L5.16905 5.5332L8.23572 8.59987Z" fill="currentColor"/>
            </svg>
          </div>
        </div>
        ${this.iconPlacement == "after" ? this.iconHTML : ""}
        <div id="select-options-${
          this.randomId
        }" class="select-items select-hide" role="listbox"></div>
      </div>
    `;
    }
  }

  connectedCallback() {
    this.select = this.selectTemplate.content.cloneNode(true);
    this.appendChild(this.select);

    this.dropdownContainer = this.querySelector(".select-items");
    this.selectSelected = this.querySelector(".select-selected");
    this.selectedItem = this.querySelector(".selected-item");
    this.customSelect = this.querySelector(".custom-select");

    // populate options
    this.populateOptions();
    // populate label if exists
    if (this.mainLabel) {
      this.populateLabel();
    }

    this.selectItems = this.querySelectorAll(".select-item");
    // set initial selected item
    this.initialSelectItem();

    this.customSelect.addEventListener("click", () => this.toggleDropdown());

if (!window.__customSelectGlobalEventsAdded) {
  window.__customSelectGlobalEventsAdded = true;

  document.addEventListener("click", function (event) {
    document.querySelectorAll("custom-select").forEach(function (select) {
      if (!select.contains(event.target)) {
        const dropdown = select.querySelector(".select-items");
        const selected = select.querySelector(".select-selected");

        if (dropdown) dropdown.classList.add("select-hide");
        if (selected) selected.setAttribute("aria-expanded", "false");
      }
    });
  });

  document.addEventListener(
    "scroll",
    function () {
      document.querySelectorAll("custom-select .select-items:not(.select-hide)").forEach(function (dropdown) {
        dropdown.classList.add("select-hide");

        const select = dropdown.closest("custom-select");
        const selected = select?.querySelector(".select-selected");
        if (selected) selected.setAttribute("aria-expanded", "false");
      });
    },
    { passive: true }
  );
}
    this.addEventListener("keyup", (event) => this.closeOnEscKey(event));
    this.addEventListener("keyup", (event) => this.openOnFocusAndEnter(event));

    //check if any item inside dropdown is focused, if not close
    this.dropdownContainer.addEventListener("focusout", (event) => {
      if (!this.contains(event.relatedTarget)) {
        this.dropdownContainer.classList.add("select-hide");
        this.removeTabIndexFromAllSelectItems();
        // set aria-expanded to false when dropdown is closed
        this.selectSelected.setAttribute("aria-expanded", "false");
      }
    });

    this.customSelect.addEventListener("focus", () => {
      this.dropdownContainer.classList.add("select-hide");
      this.removeTabIndexFromAllSelectItems();
    });
  }

  populateOptions() {
    // loop through options and create select items
    let selectItem;
    this.mainSelect.querySelectorAll("option").forEach((option) => {
      if (this.selectType === "links") {
        selectItem = document.createElement("a");
        selectItem.setAttribute("href", option.value);
      } else {
        selectItem = document.createElement("div");
      }

      selectItem.innerHTML = option.innerHTML;
      selectItem.classList.add("select-item");

      if (option.classList.contains("shoppable-market")) {
        selectItem.classList.add("shoppable-market");
      }

      selectItem.setAttribute("role", "option");
      selectItem.setAttribute("aria-selected", "false");

      if (option.selected) {
        selectItem.classList.add("selected");
        selectItem.setAttribute("aria-selected", "true");
      }

      this.dropdownContainer.appendChild(selectItem);

      // if option is disabled add disabled class and return
      if (option.disabled) {
        selectItem.classList.add("disabled");
        return;
      }

      selectItem.addEventListener("mousedown", () =>
        this.onSelectItem(option, selectItem)
      );

      // onSelect when enter key pressed and focused
      selectItem.addEventListener("keyup", (event) => {
        if (
          event.key === "Enter" &&
          option.innerHTML == document.activeElement.innerHTML
        ) {
          this.onSelectItem(option, selectItem);
        }
      });
    });
  }

  onSelectItem(option) {

    if (option.dataset.url) return window.location = option.value;

    // update selected item
    if (this.selectedItem && option) {
      this.selectedItem.innerHTML = option.innerHTML;
    }
    // remove selected class from all select items
    const selectedOption = this.querySelector("[selected]");
    if (selectedOption) {
      selectedOption.removeAttribute("selected");
    }

    this.selectItems.forEach((item) => item.classList.remove("selected"));
    // add selected class to the clicked item
    if (this.selectItems[option.index]) {
      this.selectItems[option.index].classList.add("selected");
    }
    // set aria-selected to false for all items
    this.selectItems.forEach((item) =>
      item.setAttribute("aria-selected", "false")
    );
    // set aria-selected to true for the clicked item
    this.selectItems[option.index].setAttribute("aria-selected", "true");
    // update original select and dispatch change event
    this.mainSelect.selectedIndex = option.index;

    if (
      this.selectedItem &&
      this.mainSelect.options[option.index] &&
      this.mainSelect.options[option.index].classList.contains(
        "shoppable-market"
      )
    ) {
      this.selectedItem.classList.add("shoppable-market");
    } else if (this.selectedItem) {
      this.selectedItem.classList.remove("shoppable-market");
    }
    this.mainSelect.options[option.index].setAttribute("selected", "selected");
    this.mainSelect.value = option.value;
    this.mainSelect.dispatchEvent(new Event("change"));

    if (this.selectType === "collection-sort") {
      this.closest("form").submit();
    }

    this.removeTabIndexFromAllSelectItems();
    this.dropdownContainer.classList.add("select-hide");

    const variantSelect = this.closest("variant-selects");
    if (variantSelect) variantSelect.onVariantChange();
  }

  populateLabel() {
    this.selectLabel = this.querySelector(".select-label");
    this.selectLabel.innerHTML = this.mainLabel.innerHTML;
  }

  initialSelectItem() {
    if (!this.selectedItem) return;
    this.selectedItem.innerHTML =
      this.mainSelect.options[this.mainSelect.selectedIndex].innerHTML;
    if (
      this.mainSelect.options[this.mainSelect.selectedIndex].classList.contains(
        "shoppable-market"
      )
    ) {
      this.selectedItem.classList.add("shoppable-market");
    }
  }

  toggleDropdown() {
    this.dropdownContainer.classList.toggle("select-hide");

    if (!this.dropdownContainer.classList.contains("select-hide")) {
      // set aria-expanded to true when dropdown is open
      this.selectSelected.setAttribute("aria-expanded", "true");
    } else {
      // set aria-expanded to false when dropdown is closed
      this.selectSelected.setAttribute("aria-expanded", "false");
    }
  }

  bodyClickHandler(event) {
    if (!this.contains(event.target)) {
      this.dropdownContainer.classList.add("select-hide");
      // set aria-expanded to false when dropdown is closed
      this.selectSelected.setAttribute("aria-expanded", "false");
    }
  }

  closeOnEscKey(event) {
    if (event.key === "Escape") {
      this.dropdownContainer.classList.add("select-hide");
      this.removeTabIndexFromAllSelectItems();
      this.customSelect.focus();
      // set aria-expanded to false when dropdown is closed
      this.selectSelected.setAttribute("aria-expanded", "false");
    }
  }

  moveFocusToFirsItem() {
    // focus first of currently selected item
    if (
      this.mainSelect.selectedIndex &&
      this.selectItems[this.mainSelect.selectedIndex]
    ) {
      this.selectItems[this.mainSelect.selectedIndex].focus();
    } else {
      this.selectItems[0].focus();
    }
  }

  addTabIndexToAllSelectItems() {
    this.selectItems.forEach((item) => item.setAttribute("tabindex", "0"));
  }

  removeTabIndexFromAllSelectItems() {
    this.selectItems.forEach((item) => item.removeAttribute("tabindex"));
  }

  openOnFocusAndEnter(event) {
    // open dropdown on focus and enter key
    if (
      event.key === "Enter" &&
      this.dropdownContainer.classList.contains("select-hide") &&
      this.customSelect === document.activeElement
    ) {
      this.dropdownContainer.classList.remove("select-hide");
      this.moveFocusToFirsItem();
      this.addTabIndexToAllSelectItems();
      // set aria-expanded to true when dropdown is open
      this.selectSelected.setAttribute("aria-expanded", "true");
    }
  }
}

customElements.define("custom-select", CustomSelect);

class ScrollTo extends HTMLElement {

  constructor() {
    super();
    this.listeners();
    this.mq = window.matchMedia('(max-width: 979px)');
  }

  listeners() {
    this.addEventListener('click', (e) => {
      let target = this.getAttribute('data-target');
      const mobileTarget = this.getAttribute('data-target-mobile');
      const tab = this.getAttribute('data-tab');

      if (this.mq.matches && mobileTarget) {
        target = mobileTarget;
      }

      if (tab) {
        document.dispatchEvent(
          new CustomEvent('tab:show', {
            detail: {
              data: {
                tab: tab
              }
            }
          })
        )
      }

      if (target) {
        const targetElement = document.querySelector(target);

        if (targetElement) {
          let headerHeight = 0;

          const header = document.querySelector('header.header');
          const targetPosition = targetElement.getBoundingClientRect().top;

          if (header) {
            headerHeight = header.offsetHeight;
          }

          const scrollTarget = targetPosition + window.pageYOffset - headerHeight;

          window.scrollTo({
            top: scrollTarget,
            behavior: "smooth"
          });
        }
      }

      e.preventDefault();
    });
  }
}

customElements.define('scroll-to', ScrollTo);